var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 300,
    viewBox: "0 0 342 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.011 236.59C172.58 236.59 173.852 235.318 173.852 233.749C173.852 232.18 172.58 230.908 171.011 230.908C169.442 230.908 168.169 232.18 168.169 233.749C168.169 235.318 169.442 236.59 171.011 236.59Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4651 22.6732V35.1406",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2026 28.907H94.699",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.39 101.305C206.122 101.305 181.42 100.319 158.312 93.8824C135.638 87.5907 114.821 75.3842 96.2645 61.2642C84.1161 52.0731 73.0694 44.7377 57.2967 45.8395C41.8663 46.6744 27.1106 52.4365 15.1976 62.279C-4.8662 79.8493 -1.85083 112.409 6.18048 135.199C18.2419 169.614 54.9482 193.592 86.1457 209.104C122.185 227.109 161.791 237.576 201.483 243.578C236.276 248.884 280.985 252.711 311.138 230.009C338.828 209.104 346.424 161.438 339.639 129.255C337.993 119.747 332.931 111.169 325.403 105.132C305.948 90.896 276.926 100.406 255.064 100.87C246.946 101.044 238.683 101.247 230.39 101.305Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.132 5.68281C192.702 5.68281 193.974 4.41067 193.974 2.8414C193.974 1.27214 192.702 0 191.132 0C189.563 0 188.291 1.27214 188.291 2.8414C188.291 4.41067 189.563 5.68281 191.132 5.68281Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4956 226.935V239.403",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2622 233.169H49.7296",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.171 300C230.954 300 278.608 297.027 278.608 293.36C278.608 289.693 230.954 286.721 172.171 286.721C113.388 286.721 65.7344 289.693 65.7344 293.36C65.7344 297.027 113.388 300 172.171 300Z",
    fill: "#E4E4E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.731 222.238H73.8811C72.6507 222.237 71.4352 221.969 70.3186 221.453C69.2021 220.936 68.2111 220.182 67.4142 219.245C66.6174 218.308 66.0337 217.208 65.7035 216.023C65.3733 214.838 65.3045 213.595 65.5019 212.38L89.0159 69.7883C89.3336 67.8038 90.3493 65.9979 91.8801 64.6956C93.4109 63.3933 95.3564 62.6803 97.3662 62.6848H281.217C282.446 62.685 283.661 62.9529 284.776 63.4699C285.892 63.987 286.881 64.7408 287.676 65.679C288.471 66.6171 289.051 67.7171 289.378 68.9024C289.704 70.0878 289.769 71.33 289.567 72.5428L266.169 215.135C265.843 217.132 264.813 218.946 263.266 220.249C261.718 221.552 259.755 222.258 257.731 222.238Z",
    fill: "#D2D2D2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M259.997 58.9558L150.867 10.2312C147.651 8.79501 143.879 10.2384 142.442 13.4552L107.855 90.9207C106.419 94.1375 107.862 97.9095 111.079 99.3457L220.209 148.07C223.426 149.507 227.198 148.063 228.634 144.846L263.221 67.3808C264.657 64.1641 263.214 60.3921 259.997 58.9558Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M256.92 222.18H72.1706C69.9225 222.173 67.7692 221.274 66.1823 219.682C64.5954 218.09 63.7043 215.933 63.7043 213.685V83.4155C63.6773 82.2854 63.8761 81.1612 64.2891 80.1089C64.7021 79.0566 65.321 78.0973 66.1095 77.2872C66.898 76.4771 67.8402 75.8326 68.881 75.3913C69.9217 74.95 71.0401 74.7209 72.1706 74.7173H139.465C141.027 74.7231 142.557 75.1591 143.887 75.9775C145.216 76.7959 146.295 77.965 147.004 79.3564L156.601 98.1444C157.307 99.5379 158.385 100.709 159.715 101.528C161.046 102.346 162.577 102.781 164.139 102.783H256.92C259.165 102.783 261.319 103.675 262.906 105.263C264.494 106.851 265.386 109.004 265.386 111.25V213.685C265.386 215.933 264.495 218.09 262.908 219.682C261.321 221.274 259.168 222.173 256.92 222.18Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.476 107.22C217.803 107.214 207.368 110.374 198.491 116.299C189.614 122.224 182.694 130.649 178.605 140.508C174.517 150.367 173.444 161.217 175.523 171.686C177.602 182.155 182.738 191.772 190.283 199.321C197.828 206.87 207.443 212.012 217.91 214.096C228.378 216.18 239.228 215.113 249.089 211.03C258.951 206.947 267.379 200.031 273.31 191.158C279.24 182.284 282.405 171.85 282.405 161.177C282.405 146.872 276.724 133.152 266.612 123.034C256.499 112.915 242.782 107.227 228.476 107.22Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266.865 200.319L281.246 214.7",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M279.62 207.713L275.152 212.386C273.15 214.481 273.224 217.803 275.32 219.806L314.092 256.871C316.187 258.874 319.509 258.799 321.512 256.704L325.98 252.03C327.982 249.935 327.908 246.613 325.813 244.61L287.04 207.546C284.945 205.543 281.623 205.618 279.62 207.713Z",
    fill: "#D2D2D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308.326 2.84151V15.3379",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M302.063 9.10413H314.559",
    stroke: "#BABABA",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.b6e9b2b45ad7e30decdffb5ac4d5eba2.svg";
export { ForwardRef as ReactComponent };